import React from 'react';

import { Navigate, Outlet } from 'react-router-dom';
import { UserService } from 'services/user-service';
import { ROUTE_LINKS } from 'shared/constants/route-links';

export const CustomOrganisationGuard = () => {
  return UserService.isCustomOrganisationMember() ? <Outlet /> : <Navigate to={ROUTE_LINKS.smartAssistants} />;
};
